module.exports = __webpack_public_path__ + "img/img_discount.b4dde1d3.png";